var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoClear96X96(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "879.44348mm",
    height: "1197.6248mm",
    viewBox: "0 0 879.44348 1197.6248",
    id: "svg1",
    inkscapeVersion: "1.3.2 (091e20e, 2023-11-25)",
    sodipodiDocname: "logo.svg",
    xmlSpace: "preserve",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    "inkscapeDocument-units": "mm",
    inkscapeZoom: 0.014142136,
    inkscapeCx: 15697.771,
    inkscapeCy: 5550.7882,
    inkscapeWindowWidth: 1366,
    inkscapeWindowHeight: 731,
    inkscapeWindowX: 0,
    inkscapeWindowY: 0,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "g57"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Layer 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    transform: "translate(-4113.0538,-896.83323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17",
    transform: "translate(1739.1198,-2278.5294)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g57",
    transform: "translate(1278.3198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "matrix(1.3504812,0,0,1.3504812,-2371.3905,3936.2737)",
    inkscapeExportFilename: "final.svg",
    inkscapeExportXdpi: 96,
    inkscapeExportYdpi: 96
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1a1a1a",
      fillOpacity: 1,
      strokeWidth: 0.509489
    },
    id: "rect59",
    width: 190,
    height: 938.05133,
    x: 2651.5378,
    y: -595.99109,
    ry: 100.48888,
    transform: "matrix(1,0,-0.32597561,0.94537818,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    style: {
      fill: "#A94064",
      fillOpacity: 1,
      strokeWidth: 0.238098
    },
    d: "m 3142.8104,-53.467329 64.1599,102.283 c 24.4479,38.974697 17.3923,86.589579 -96.9432,128.363009 l -191.1175,69.8264 c -57.3781,20.9636 -128.5664,1.6714 -110.1977,-52.6824 l 50.1846,-148.499309 c 18.3687,-54.3537001 39.4479,-110.6816 96.9431,-128.3632 l 76.7733,-23.609701 c 57.4951,-17.68169 85.7496,13.707804 110.1975,52.682201 z",
    sodipodiNodetypes: "sssssssss"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#1a1a1a",
      fillOpacity: 1,
      strokeWidth: 0.238098
    },
    d: "m 3142.8104,-53.467329 64.1599,102.283 c 24.4479,38.974697 17.3923,86.589579 -96.9432,128.363009 l -191.1175,69.8264 c -57.3781,20.9636 -120.0757,-1.43155 -101.4493,-48.42661 6.5405,-10.66791 15.7188,-15.40315 26.8521,-20.59645 154.1083,-71.88611 171.4896,-99.539933 210.6982,-263.842756 1.3365,-5.600568 2.3006,-7.785187 6.1733,-12.85838 13.7484,-14.068814 51.8085,-2.283774 81.6265,45.251787 z",
    sodipodiNodetypes: "sssccsscs"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClear96X96);
export default __webpack_public_path__ + "static/media/logo_clear_96x96.acf19990d7032f920b61de78c1110e11.svg";
export { ForwardRef as ReactComponent };